<template>
    <b-modal id="modal_form"
             ref="modal_form"
             :title="modal_titulo"
             :ok-title="modal_botao"
             close-title="Fechar"
             cancel-title="Cancelar"
             size="lg"
             :ok-disabled=form.errors.any()
             v-model="showModal"
             @ok="handleOk">

        <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
            <b-row no-gutters>
                <b-col v-if="this.modal_acao=='u'">
                    <label tag="div">Código</label>
                    <b-form-input type="text"
                                 placeholder="Código"
                                 v-model="form.cd"
                                 name="cd">
                    </b-form-input>
                    <b-form-feedback v-text="form.errors.get('cd')" v-if="form.errors.has('cd')"></b-form-feedback>
                </b-col>
                <b-col>
                    <label>Pessoa</label>
                    <multiselect v-model="pessoaSelected"
                    :options-limit="300"
                    :limit="2"
                    :limit-text="limitText"
                    :options="optionsPessoa"
                    track-by="value"
                    label="label"
                    :hide-selected="true"
                    placeholder="Pessoa ( Digite 3 caracteres para pesquisar )"
                    tag-placeholder="Selecionar"
                    select-label="Selecionar"
                    selected-label="Selecionado"
                    deselect-label="Remover"
                    :searchable="true"
                    :loading="isLoadingPessoa"
                    @search-change="listaPessoa"
                    ></multiselect>
                    <b-form-feedback v-text="form.errors.get('pessoa_id')" v-if="form.errors.has('pessoa_id')"></b-form-feedback>
                </b-col>
                <b-col>
                    <label tag="div">Status</label>
                    <b-form-group>
                      <b-form-radio-group
                        v-model="form.status"
                        :options="optionsLivStatus"
                        name="status"
                        plain
                        stacked
                        value-field="value"
                      ></b-form-radio-group>
                    </b-form-group>
                </b-col>
                <b-col>
                    <label tag="div">Tipo Autenticação</label>
                    <b-form-group>
                      <b-form-radio-group
                        v-model="form.tp_autenticacao"
                        :options="optionsLivTpAutenticacao"
                        name="tp_autenticacao"
                        plain
                        stacked
                        value-field="value"
                      ></b-form-radio-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row no-gutters>
                <b-col>
                    <label tag="div">Host</label>
                    <b-form-input type="text"
                                 placeholder="Host"
                                 v-model="form.host"
                                 name="host">
                    </b-form-input>
                    <b-form-feedback v-text="form.errors.get('host')" v-if="form.errors.has('host')"></b-form-feedback>
                </b-col>
                <b-col>
                    <label tag="div">Usuario</label>
                    <b-form-input type="text"
                                 placeholder="Usuario"
                                 v-model="form.usuario"
                                 name="usuario">
                    </b-form-input>
                    <b-form-feedback v-text="form.errors.get('usuario')" v-if="form.errors.has('usuario')"></b-form-feedback>
                </b-col>
                <b-col>
                    <label tag="div">Senha</label>
                    <b-form-input type="text"
                                 placeholder="Senha"
                                 v-model="form.senha"
                                 name="senha">
                    </b-form-input>
                    <b-form-feedback v-text="form.errors.get('senha')" v-if="form.errors.has('senha')"></b-form-feedback>
                </b-col>
            </b-row>

        </form>
        <div slot="modal-footer" class="w-100">
            <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
            <div class="float-right">
                 <b-btn @click="showModal=false" variant="secondary">
                   Fechar
                 </b-btn>
                 <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                   Enviar
                 </b-btn>
            </div>
        </div>
    </b-modal>
</template>
<script>

export default {
components: {
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
      dataExport: [],
      modal_titulo: '',
      modal_botao: '',
      modal_acao: '',
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isLoadingPessoa: false,
      statusSelected: [],
      optionsLivStatus: [],
      pessoaSelected: [],
      optionsPessoa: [],
      optionsLivTpAutenticacao: [],
      tpAutenticacaoSelected: [],
      form: new Form({ cd: '',
                       host: '',
                       pessoa_id: '',
                       usuario: '',
                       senha: '',
                       status: '',
                       tp_autenticacao: '',
                       pesconftp_id: ''
                   }),
     helpForm: new Form({statusRecord: [], params: [], search: ''}),
    fields: [],
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},
watch: {
    statusSelected(obj) {
        this.form.status = obj.value;
    },
    tpAutenticacaoSelected(obj) {
        this.form.tp_autenticacao = obj.value;
    },
    pessoaSelected(obj) {
        this.form.pessoa_id = obj.value;
    }
},
mounted() {
    this.getLivGeral();
  },
methods: {
    handleOk(e)
    {
        e.preventDefault();
        if(this.modal_acao=="i")
        {
           this.onStore();
        }
        else
        {
            this.onUpdate(this.form.pesconftp_id);
        }
    },
    onCreate ()
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar Conexão Email";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.form.reset();
      this.statusSelected = [];
      this.pessoaSelected = [];
      this.tpAutenticacaoSelected = [];
      this.$refs.modal_form.show();
    },
    onEdit (data, index, id)
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar Conexão Email";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.statusSelected = [];
      this.pessoaSelected = [];
      this.tpAutenticacaoSelected = [];
      this.form.cd = data.cd;
      this.form.host = data.host;
      this.form.usuario = data.usuario;
      this.form.senha = data.senha;
      this.statusSelected = { label: data.status.descr, value: data.status.valor };
      if(data.pessoa!==null)
      {
          if(data.pessoa.pessoa_fisica!==null)
          {
              this.pessoaSelected = { label: "PF -"+data.pessoa.pessoa_fisica.nome+" - "+data.pessoa.pessoa_fisica.cpf, value: data.pessoa_id }
          }
          else if(data.pessoa.pessoa_juridica!==null)
          {
              this.pessoaSelected = { label: "PJ -"+data.pessoa.cd+" - "+data.pessoa.pessoa_juridica.razao_social+" - "+this.onFormataCnpj(data.pessoa.pessoa_juridica.cnpj_base,data.pessoa.pessoa_juridica.cnpj_filial,data.pessoa.pessoa_juridica.cnpj_digito)+" - "+data.pessoa.pessoa_juridica.inscricao_estadual, value: data.pessoa_id }
          }
          else if(data.pessoa.pessoa_exterior!==null)
          {
              this.pessoaSelected = { label: "PE -"+data.pessoa.pessoa_exterior.nome+" - "+data.pessoa.pessoa_exterior.cd, value: data.pessoa_id }
          }
      }
      this.form.pesint_id = data.pesint_id;
      this.$refs.modal_form.show();
    },
    onStore()
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.put('/api/pessoaconexaoemail/store').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });
    },
    onUpdate(id)
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.patch('/api/pessoaconexaoemail/update/'+id).then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });
    },
    getLivGeral() {
        this.helpForm.get('/api/pessoaconexaoemail/jsonlistgeral').then(response =>
        {
            new ReturnApi(response, this, true, false, false);
            response.status.forEach((obj)=>
            {
                this.optionsLivStatus.push({ text: obj.descr, value: obj.valor })
            })
            response.tp_autenticacao.forEach((obj)=>
            {
                this.optionsLivTpAutenticacao.push({ text: obj.descr, value: obj.valor })
            })
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, false, false)
        });
    },
    listaPessoa(search) {
        if(search.length>=3)
        {
            this.isLoadingPessoa = true;
            this.helpForm.search = search;
            this.helpForm.status = 1;
            this.helpForm.post('/api/pessoa/jsonlist').then(response =>
            {
                this.optionsPessoa = [];
                new ReturnApi(response, this, true, false, false);
                if(response.items.length>0)
                {
                    response.items.forEach((obj)=>
                    {
                        this.optionsPessoa.push({ label: "PJ -"+obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                    });
                }
                if(response.itemsF.length>0) {
                    response.itemsF.forEach((obj)=>
                    {
                        this.optionsPessoa.push({ label: "PF -"+obj.nome+" - "+obj.cpf, value: obj.pessoa_id })
                    });
                }
                if(response.itemsE.length>0)
                {
                    response.itemsE.forEach((obj)=>
                    {
                        this.optionsPessoa.push({ label: "PE -"+obj.nome+" - "+obj.cd, value: obj.pessoa_id })
                    });
                }
                this.isLoadingPessoa = false;
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
              });
        }
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito)
    {
        var cnpj_formatado
        var pad = "00000000"
        var cnpj_base = pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
        var pad = "0000"
        var cnpj_filial = pad.substring(0, pad.length - cnpj_filial.toString().length) + cnpj_filial;
        var pad = "00"
        var cnpj_digito = pad.substring(0, pad.length - cnpj_digito.toString().length) + cnpj_digito;

        return cnpj_base+""+cnpj_filial+""+cnpj_digito;
    },
    limitText (count) {
        return ' e ${count} outros clientes'
    },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>
